module.exports = __webpack_public_path__ + "img/tz.d02545a1.svg";